<template>
  <div class="nav-container" v-scroll="onScroll">
    <app-bar :is-mobile="isMobile" :offset-top="offsetTop" />
    <app-bottom-nav v-if="isMobile" />
    <scroll-to-top :is-mobile="isMobile" :offset-top="offsetTop" />
  </div>
</template>

<script>
import AppBar from '@/components/nav/AppBar.vue';
import AppBottomNav from '@/components/nav/BottomNav.vue';
import ScrollToTop from '@/components/nav/ScrollToTop.vue';

export default {
  name: 'app-nav',
  components: { AppBar, AppBottomNav, ScrollToTop },
  data: () => ({
    offsetTop: window ? window.pageYOffset : 0,
  }),
  methods: {
    onScroll(e) {
      if (window) {
        this.offsetTop = window.pageYOffset || e.target.scrollTop || 0;
      }
    },
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
};
</script>
